function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { EmailShareButton, WhatsappShareButton, FacebookShareButton, TwitterShareButton } from "react-share";
import Modal from "../../../Common/Modal";
import { copyCodeHandler } from "../../../../utils/helpers";
import SiWhatsapp from "@meronex/icons/si/SiWhatsapp";
import EiCloseO from "@meronex/icons/ei/EiCloseO";
import FaFacebookF from "@meronex/icons/fa/FaFacebookF";
import useData from "../../Molecules/Content/data";
import FiCopy from "@meronex/icons/fi/FiCopy.js";
import MdcEmailOutline from "@meronex/icons/mdc/MdcEmailOutline";
import { DetailProjectLoadingUI, LoadingSpinner } from "../../../Common/LoadingUI";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VRGallery = function VRGallery(props) {
  var _config$projects;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    VRLink = _useState4[0],
    setVRLink = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    copiedUrl = _useState6[0],
    setCopiedUrl = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showShareModal = _useState8[0],
    setShowShareModal = _useState8[1];
  var _useState9 = useState(""),
    _useState0 = _slicedToArray(_useState9, 2),
    shareLink = _useState0[0],
    setShareLink = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    clickedVrItem = _useState10[0],
    setClickedVrItem = _useState10[1];
  var config = props.config;
  var shareMessage = "Transform your vision into reality with your dream home: ";
  var location = props.location;
  var queryParams = new URLSearchParams(location.search);
  var projectId = queryParams.get("projectId");
  var _useData = useData(projectId, {
      winnreNoAuth: props.winnreNoAuth
    }),
    projectDetails = _useData.projectDetails,
    VrGallery = _useData.VrGallery;
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    vrLinks = _useState14[0],
    setVrLinks = _useState14[1];
  useEffect(function () {
    var links = VrGallery.map(function (vrItem) {
      return vrItem.url;
    });
    setVrLinks(links);
  }, [VrGallery]);
  var userId = props.userId;
  var link = "".concat(window.location.href.split("?")[0], "?projectId=").concat(projectId, "&userId=").concat(userId);
  var userHash = queryParams.get("userId");
  var openVRView = function openVRView(link) {
    setShowModal(false); // Close any open modal
    setShowShareModal(false); // Close share modal if open
    setVRLink(link);
    setShowModal(true);
  };
  var handleCopyCode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(VRLink) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return copyCodeHandler(VRLink, setCopiedUrl);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCopyCode(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  // useEffect(() => {
  //     if (copiedUrl) {
  //         const timer = setTimeout(() => {
  //             setCopiedUrl(false);
  //         }, 2000);
  //         return () => clearTimeout(timer);
  //     }
  // }, [copiedUrl]);

  useEffect(function () {
    if (userHash) {
      var url = "https://api.in.webengage.com/v1/accounts/".concat(config === null || config === void 0 ? void 0 : config.webengageLic, "/events");
      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer ".concat(config === null || config === void 0 ? void 0 : config.WAK)
        },
        body: JSON.stringify({
          userId: userHash,
          eventName: "InfluencerLinkViewed",
          eventData: {
            ProjectName: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName
          }
        })
      };
      fetch(url, requestOptions).then(function (res) {
        // console.log(res);
      })["catch"](function (err) {
        // console.log(err);
      });
    }
  }, [userHash]);
  var handleShareClick = function handleShareClick(obj) {
    setClickedVrItem(obj);
    setShowShareModal(true);
    setCopiedUrl(false);
    setShareLink(obj.url);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mt-5",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/_jsx("h4", {
          className: "z-10 text-xl mt-2 text-[#130E2F] font-bold ".concat(config.fontTitle),
          children: "AR/VR"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: " ".concat(config.fontBody, " grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"),
        children: VrGallery === null || VrGallery === void 0 ? void 0 : VrGallery.map(function (obj) {
          return /*#__PURE__*/_jsx("div", {
            className: "border-2 flex flex-col hover:border-primary cursor-pointer rounded-lg p-2 lg:p-5",
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col h-full justify-start",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "relative",
                onClick: function onClick() {
                  setClickedVrItem(obj);
                  openVRView(obj === null || obj === void 0 ? void 0 : obj.url);
                },
                children: [/*#__PURE__*/_jsx("img", {
                  className: "rounded h-40 lg:h-28 xl:h-56 w-full",
                  src: obj === null || obj === void 0 ? void 0 : obj.thumbnailUrl
                }), /*#__PURE__*/_jsx("button", {
                  className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#000000B3] mt-2 text-white text-center px-4 py-2",
                  children: "TAP TO EXPERIENCE"
                })]
              }), /*#__PURE__*/_jsx("h1", {
                className: "font-semibold mt-2",
                children: obj === null || obj === void 0 ? void 0 : obj.caption
              }), /*#__PURE__*/_jsx("p", {
                className: "text-sm",
                children: obj === null || obj === void 0 ? void 0 : obj.tagLine
              }), /*#__PURE__*/_jsx("div", {
                className: "flex justify-end mt-auto",
                children: /*#__PURE__*/_jsx("button", {
                  className: "bg-white rounded-full p-2",
                  onClick: function onClick() {
                    return handleShareClick(obj);
                  },
                  children: /*#__PURE__*/_jsx("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18.277",
                    height: "16.312",
                    viewBox: "0 0 18.277 16.312",
                    className: "w-5 h-5",
                    children: /*#__PURE__*/_jsx("path", {
                      id: "_10131836_share_line_icon",
                      "data-name": "10131836_share_line_icon",
                      d: "M20,12,13.6,5V8.5C10.4,8.5,4,10.6,4,19c0-1.167,1.92-3.5,9.6-3.5V19Z",
                      transform: "translate(0.166 -4.42) rotate(9)",
                      fill: "none",
                      stroke: "#16519e",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "2"
                    })
                  })
                })
              })]
            })
          }, obj === null || obj === void 0 ? void 0 : obj.url);
        })
      })]
    }), showModal && /*#__PURE__*/_jsx(Modal, {
      visible: showModal,
      onClick: function onClick() {
        setVRLink(null);
        setShowModal(false);
      },
      className: "w-full lg:w-[95%] h-full lg:h-[90%] m-auto",
      showCloseButton: true,
      showButton: false,
      children: /*#__PURE__*/_jsx("iframe", {
        allowFullScreen: true,
        width: "100%",
        height: "100%",
        src: VRLink
      })
    }), showShareModal && clickedVrItem && /*#__PURE__*/_jsx(Modal, {
      visible: showShareModal,
      showButton: true,
      showCloseButton: false,
      onClick: function onClick() {
        setVRLink(null);
        setClickedVrItem(null);
        setShowShareModal(false);
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col px-5",
        children: [loading && /*#__PURE__*/_jsx(LoadingSpinner, {}), !loading && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex justify-between items-center my-4",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "text-lg sm:text-xl font-bold",
              children: "Share AR/VR"
            }), /*#__PURE__*/_jsx(EiCloseO, {
              onClick: function onClick() {
                return setShowShareModal(false);
              },
              className: "h-7 w-7 sm:h-9 sm:w-10 cursor-pointer text-gray-500"
            })]
          }), /*#__PURE__*/_jsxs("svg", {
            viewBox: "0 0 457 2",
            children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
              id: "Layer_2",
              "data-name": "Layer 2",
              children: /*#__PURE__*/_jsx("g", {
                id: "Layer_1-2",
                "data-name": "Layer 1",
                children: /*#__PURE__*/_jsx("polygon", {
                  className: "cls-1",
                  points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                  fill: "#e5e5e5"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex gap-5 items-center my-5",
            children: [/*#__PURE__*/_jsx("img", {
              variant: "square",
              loading: "lazy",
              className: "".concat(config !== null && config !== void 0 && (_config$projects = config.projects) !== null && _config$projects !== void 0 && (_config$projects = _config$projects.moduleConfig) !== null && _config$projects !== void 0 && _config$projects.QRCodeImage ? "h-10 w-10" : "h-20 w-28", " z-10 object-center object-cover rounded-lg"),
              src: clickedVrItem === null || clickedVrItem === void 0 ? void 0 : clickedVrItem.thumbnailUrl,
              alt: "property"
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col",
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-black font-semibold text-base sm:text-lg",
                children: clickedVrItem === null || clickedVrItem === void 0 ? void 0 : clickedVrItem.caption
              }), /*#__PURE__*/_jsx("p", {
                className: "text-[#908F95] text-sm sm:text-base italic",
                children: clickedVrItem === null || clickedVrItem === void 0 ? void 0 : clickedVrItem.tagLine
              })]
            })]
          }), /*#__PURE__*/_jsxs("svg", {
            viewBox: "0 0 457 2",
            children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
              id: "Layer_2",
              "data-name": "Layer 2",
              children: /*#__PURE__*/_jsx("g", {
                id: "Layer_1-2",
                "data-name": "Layer 1",
                children: /*#__PURE__*/_jsx("polygon", {
                  className: "cls-1",
                  points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                  fill: "#e5e5e5"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-wrap justify-between items-center mt-5",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-[90%] lg:w-[45%] md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
              children: /*#__PURE__*/_jsxs("button", {
                title: copiedUrl ? "Link copied" : "Click to copy",
                className: "",
                onClick: function onClick() {
                  return handleCopyCode(shareLink);
                },
                children: [!copiedUrl && /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-3",
                  children: [/*#__PURE__*/_jsx(FiCopy, {
                    className: "cursor-pointer w-5 h-full"
                  }), /*#__PURE__*/_jsx("p", {
                    className: "font-bold text-sm sm:text-base",
                    children: "Link Copy"
                  })]
                }), copiedUrl && /*#__PURE__*/_jsx("p", {
                  className: "mx-auto px-6 self-center rounded-lg text-center font-normal animate-pulse bg-white text-xs sm:text-sm text-[#006EB7]",
                  children: "Link Copied"
                })]
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[90%] lg:w-[45%] md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
              children: /*#__PURE__*/_jsx(EmailShareButton, {
                url: shareLink,
                title: shareMessage,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-3",
                  children: [/*#__PURE__*/_jsx(MdcEmailOutline, {
                    className: "w-5 h-full"
                  }), /*#__PURE__*/_jsx("p", {
                    className: "font-bold text-sm sm:text-base",
                    children: "Email"
                  })]
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[90%] lg:w-[45%] md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
              children: /*#__PURE__*/_jsx(WhatsappShareButton, {
                url: shareLink,
                title: shareMessage,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-3",
                  children: [/*#__PURE__*/_jsx(SiWhatsapp, {
                    className: "w-5 h-full"
                  }), /*#__PURE__*/_jsx("p", {
                    className: "font-bold text-sm sm:text-base",
                    children: "WhatsApp"
                  })]
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[90%] lg:w-[45%] md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
              children: /*#__PURE__*/_jsx(FacebookShareButton, {
                url: shareLink,
                title: shareMessage,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-3",
                  children: [/*#__PURE__*/_jsx(FaFacebookF, {
                    className: "w-5 h-full"
                  }), /*#__PURE__*/_jsx("p", {
                    className: "font-bold text-sm sm:text-base",
                    children: "Facebook"
                  })]
                })
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "w-[90%] lg:w-[45%] md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
              children: /*#__PURE__*/_jsx(TwitterShareButton, {
                url: shareLink,
                title: shareMessage,
                children: /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-3",
                  children: [/*#__PURE__*/_jsx("svg", {
                    size: 20,
                    className: "w-5 text-black",
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: "0",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/_jsx("path", {
                      d: "M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"
                    })
                  }), /*#__PURE__*/_jsx("button", {
                    className: "font-bold text-sm sm:text-base",
                    children: "Twitter"
                  })]
                })
              })
            })]
          })]
        })]
      })
    })]
  });
};
export default VRGallery;